import * as _ from 'lodash';
import {
  FETCH_PRODUCTS_SUCCEEDED,
  FILTER_PRODUCT_SUCCEEDED,
  MAP_CATEGORIES_TO_PRODUCTS,
  FETCH_PRODUCTS_REQUESTED,
  FETCH_PARTNER_PRODUCT_SUCCEEDED,
  BULK_UPDATE_PRODUCT_SUCCEEDED,
  BULK_UPDATE_PRODUCT_FAILED,
  BULK_UPDATE_PRODUCT_COMPLETE,
  BULK_UPDATE_PRODUCT_REQUESTED,
  REINDEX_PRODUCT_REQUESTED,
  REINDEX_PRODUCT_SUCCEEDED,
  REINDEX_PRODUCT_COMPLETED,
  REINDEX_SELECTED_PRODUCT_ITEM,
  SELECT_ALL_VISIBLE_PRODUCT,
  SEND_PRODUCT_TO_PARTNER_QUEUE_REQUESTED, FILTER_PRODUCT_REQUESTED, SELECT_ALL_PRODUCT, RESET_PRODUCT_SELECTION
} from './list.actions';

export const list = (state = {
  fetched: false, items: [], loading: false,
  partners: [], bulkUpdateReceipt: null, reindexProductsReceipt: '', reindexProductsStarted: false,
  checked: false, checkedItems: [], allChecked: false
}, action) => {
  switch (action.type) {
    case REINDEX_PRODUCT_REQUESTED:
      return _.assign({}, state, {
        reindexProductsReceipt: '',
        reindexProductsStarted: true
      });
    case REINDEX_PRODUCT_SUCCEEDED:
      return _.assign({}, state, {
        reindexProductsReceipt: action.data,
        reindexProductsStarted: true
      });
    case REINDEX_PRODUCT_COMPLETED:
      return _.assign({}, state, {
        reindexProductsReceipt: '',
        reindexProductsStarted: false
      });
    case FETCH_PRODUCTS_REQUESTED:
      let checkedItems = [...state.checkedItems];
      if (action.data.untouched) {
        checkedItems = [];
      } else {
        state.items.forEach(s => {
          checkedItems = checkedItems.filter(item => item.id !== s.id);
          checkedItems.push(s);
        });
      }
      return _.assign({}, state, {
        fetched: false,
        loading: true,
        checked: state.checked,
        checkedItems: checkedItems,
        allChecked: false
      });
    case FETCH_PRODUCTS_SUCCEEDED:
      let newCheckedItems = [...state.checkedItems];
      let newItems = action.data.map(s => {
        let originalState = state['checkedItems'].find(item => item.id === s.id );
        if (originalState) {
          s.checked = originalState.checked;
        } else {
          if (action.untouched) {
            if (!(_.isNil(action.defaultSelection) || _.isUndefined(action.defaultSelection))) {
              s.checked = action.defaultSelection;
            }
          }
          newCheckedItems.push(s);
        }
        return s;
      });
      return _.assign({}, state, {
        fetched: true,
        loading: false,
        items: [
          ...newItems
        ],
        pagination: action.pagination,
        checked: newItems.filter(s => s.checked).length === newItems.length,
        checkedItems: newCheckedItems,
        allChecked: false
      });
    case REINDEX_SELECTED_PRODUCT_ITEM:
      checkedItems = [...state.checkedItems];
      state.items.forEach(s => {
        checkedItems = checkedItems.filter(item => item.id !== s.id);
        checkedItems.push(s);
      });
      return _.assign({}, state, {
        checkedItems: checkedItems
      });

    case MAP_CATEGORIES_TO_PRODUCTS:
      return _.assign({}, state);
    case FETCH_PARTNER_PRODUCT_SUCCEEDED:
      return _.assign({}, state, {
        partners: action.data
      });

    case BULK_UPDATE_PRODUCT_REQUESTED:
      return _.assign({}, state, {items: state.items});
    case BULK_UPDATE_PRODUCT_COMPLETE:
      return _.assign({}, state, {items: state.items, bulkUpdateReceipt: action.data});
    case BULK_UPDATE_PRODUCT_FAILED:
      return _.assign({}, state, {items: state.items, bulkUpdateReceipt: ''});
    case RESET_PRODUCT_SELECTION:
      return _.assign({}, state, {
        checkedItems: [],
        items: state.items.map(s => {
          s.checked = false;
          return s;
        })
      });
    case BULK_UPDATE_PRODUCT_SUCCEEDED:
      return _.assign({}, state, {
        bulkUpdateReceipt: '',
        checkedItems: [],
        items: state.items.map(s => {
          s.checked = false;
          return s;
        })
      });
    case SEND_PRODUCT_TO_PARTNER_QUEUE_REQUESTED:
      return _.assign({}, state, {
        bulkUpdateReceipt: '',
        checkedItems: [],
        items: state.items.map(s => {
          s.checked = false;
          return s;
        })
      });
    case FILTER_PRODUCT_SUCCEEDED:
      return _.assign({}, state, {
        fetched: true,
        loading: false,
        checkedItems: [],
        items: _.map(action.data, item => _.assign(item, {checked: false})),
        total: action.total,
        pagination: action.pagination
      });
    case SELECT_ALL_VISIBLE_PRODUCT:
      if (state['fetched'] === true) {
        let newStateItems = state['items'].map(s => {
          s.checked = action.data;
          return s;
        });
        let modifiedCheckedItems = [...state.checkedItems];
        newStateItems.forEach(s => {
          modifiedCheckedItems = modifiedCheckedItems.filter(item => item.id !== s.id);
          modifiedCheckedItems.push(s);
        });
        return _.assign({}, state, {
          fetched: true,
          items: [
            ...newStateItems
          ],
          total: state['total'],
          checked: action.data,
          checkedItems: modifiedCheckedItems,
          allChecked: false
        });
      } else {
        return state;
      }
    case SELECT_ALL_PRODUCT:
      if (state['fetched'] === true) {
        return _.assign({}, state, { allChecked: true });
      } else {
        return state;
      }
    default:
      return state;
  }
};
